import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { CareComponentService } from './shared';
import { AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { HeaderService } from './../header/header.service';
import { PageLoaderService } from '../../../lib/ng2-sapmp/src/ui-components/page-loader/';
declare var GLOBAL_LOGON_URL;
@Component({
  selector: 'app-care',
  providers: [CareComponentService],
  templateUrl: './care.component.html',
  styleUrls: ['./care.component.scss']
})
export class CareComponent implements OnInit, OnDestroy {
  private ADDP_PROTAL_PATHNAME: any;
  private GOLBAL_LOGON_CALLING_URI: any;
  private ADDP_RETURN_URL_ENCODED: any;
  id: any;
  is_carelogin: String;
  elements: Array<HTMLElement>;
  private agentProfileData: any;
  private rkey: string;

  constructor(private authenticationService: AuthenticationService,
    private careService: CareComponentService,
    private router: Router, private route: ActivatedRoute,
    private utilityService: UtilityService,
    private pageloaderService: PageLoaderService,
    private headerService: HeaderService,
    private breadCrumbService: BreadCrumbService) {

    this.is_carelogin = this.authenticationService.getAuthToken('CARE_LOGON');
    this.agentProfileData = this.careService.getCareModel();

    this.utilityService.getPageLoadChecklist().subscribe(status => {
      if (!status &&
        <HTMLElement>document.querySelector('#userProfileInfo') &&
        <HTMLElement>document.querySelector('#hamNav')
      ) {
        var elements = <HTMLElement>document.querySelector('#userProfileInfo');
        elements.style.display = 'none';
        elements.setAttribute('tabindex', '-1');
        var elements = <HTMLElement>document.querySelector('#hamNav');
        elements.style.display = 'none';
        elements.setAttribute('tabindex', '-1');
        // this.headerService.checkCart();
        this.utilityService.setPageLoadChecklist(true);
      }
    });
  }

  ngOnInit() {
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Home', routerLink: '/home' });
    this.pageloaderService.setPageLoaderStatus(false);
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    const fanId = this.router.parseUrl(this.router.url).queryParams['fanInContext'];
    const client = this.router.parseUrl(this.router.url).queryParams['client'];
    const rkey = this.router.parseUrl(this.router.url).queryParams['rkey'];
    const attId = this.router.parseUrl(this.router.url).queryParams['attId'];
    const myattUserId = this.router.parseUrl(this.router.url).queryParams['myattUserId'];
    const attESSec = this.authenticationService.getCookie('attESSec');
    const attESHr = this.authenticationService.getCookie('attESHr');

    this.rkey = (rkey) ? rkey : (client) ? client : '';
    

    // if (client && attId) {
    //   //PREMIER LIC FLOW
    //   sessionStorage.setItem('client', client);
    //   sessionStorage.setItem('attId', attId);
    //   if (fanId) {
    //       this.careLogin(fanId);
    //       this.authenticationService.setLoginSuccessUrl('/dashboard');
    //   } else {
    //       this.careLoginNoID();
    //   }
    // } else {
    //   this.router.navigate(['care/home'])
    // }
    if(fanId) {
      this.router.navigate(['care/searchFan']);
      sessionStorage.setItem('fanInContext', fanId);
    }
  }

  gloablLogin() {
    this.ADDP_PROTAL_PATHNAME = window.location.href;
    this.ADDP_RETURN_URL_ENCODED = encodeURIComponent(this.ADDP_PROTAL_PATHNAME);
    this.GOLBAL_LOGON_CALLING_URI = GLOBAL_LOGON_URL + this.ADDP_RETURN_URL_ENCODED + '&encReturnURL&sysName=CSP';
    window.location.href = this.GOLBAL_LOGON_CALLING_URI;
    this.pageloaderService.setPageLoaderStatus(true);
  }

 // LIC (care) login
 careLogin(fanId) {
  const loginSuccessUrl = this.authenticationService.getLoginSuccessUrl();
  const rkey = loginSuccessUrl ? loginSuccessUrl.replace('home', '/care') : '/dashboard-title';
  this.authenticationService.careServiceLogin(this.router.parseUrl(this.router.url).queryParams['fanInContext'], loginSuccessUrl)
    .subscribe(resp => {
      if (resp.jwtToken !== null && resp.jwtToken !== '' && resp.jwtToken !== undefined) {
        this.authenticationService.setAuthToken('authToken', resp.jwtToken);
        sessionStorage.setItem('sapmp_jwtToken', resp.jwtToken);
        if(!sessionStorage.getItem('sessionId')){
        sessionStorage.setItem('sessionId', resp.sessionId);
        }
        this.agentProfileData.agentName = resp.agentName;
        this.agentProfileData.customerName = resp.customerName;
        this.agentProfileData.agentUserId = resp.agentUserId;
        this.agentProfileData.customerEmail = resp.customerEmail;
        this.agentProfileData.tcmAopEmailAddress = resp.tcmAopEmailAddress;
        this.agentProfileData.searchFan = '';
        this.careService.setCareModel(this.agentProfileData);
        this.router.navigate(['care/dashboardTitle'], { queryParams: { 'fanInContext': fanId } });
      }else if (resp.errorCode) {
        this.handleFanError(resp.errorCode);
      }
    }, error => {
      this.handleLoginError();
    });
}

careLoginNoID() {
  const loginSuccessUrl = this.authenticationService.getLoginSuccessUrl();
  const rkey = loginSuccessUrl ? loginSuccessUrl.replace('home', '/care') : '/search-fan';
  this.authenticationService.careServiceLoginNoID(loginSuccessUrl)
    .subscribe(resp => {
      if (resp.jwtToken !== null && resp.jwtToken !== '' && resp.jwtToken !== undefined) {
        this.authenticationService.setAuthToken('authToken', resp.jwtToken);
        sessionStorage.setItem('sapmp_jwtToken', resp.jwtToken);
        if(!sessionStorage.getItem('sessionId')){
        sessionStorage.setItem('sessionId', resp.sessionId);
        }
        this.agentProfileData.agentName = resp.agentName;
        this.agentProfileData.customerName = resp.customerName;
        this.careService.setCareModel(this.agentProfileData);
        this.router.navigate(['/care/searchFan']);
      } else if (resp.errorCode) {
        this.handleFanError(resp.errorCode);
      }
    }, error => {
      this.handleLoginError();
    });
}
  handleLoginError() {
    /** need to handle error scenarios */
    this.pageloaderService.setPageLoaderStatus(true);
    setTimeout(() => { this.headerService.logoutDeleteSession(); }, 5000);
    this.router.navigate(['errorPage', '500']);
  };
  handleFanError(errorCode) {
    this.pageloaderService.setPageLoaderStatus(true);
    this.router.navigate(['errorPage', errorCode]);
  }
  ngOnDestroy() {
  }
}
